import React from "react";
import Product from "./Product";
import "./bestseller.css";
import tengol from "./tengol.png";
import besan_laddoo from "./besan_laddoo.png";

function BestSeller() {
  return (
    <div className="best_seller">
      <h3 className="best_seller_title">BEST SELLERS</h3>
      <div className="best_seller_list">
        <div className="best_seller_products">
          <Product
            id="1"
            title="ಬೇಸನ್ ಉಂಡೆ | Besan Laddoo"
            category="powder"
            image={besan_laddoo}
            price="450"
          />
        </div>

        <div className="best_seller_products">
          <Product
            id="2"
            title="ಪುರಿ ಉಂಡೆ | Puri Unde"
            category="box"
            image="https://m.media-amazon.com/images/I/41hzY651KAL._AC_UL480_QL65_.jpg"
            price="96"
          />
        </div>

        <div className="best_seller_products">
          <Product
            id="10"
            title="ತೆಂಗೊಳಲು | Tengolu"
            category="powder"
            image={tengol}
            price="380"
          />
        </div>

        <div className="best_seller_products">
          <Product
            id="8"
            title="ನಿಪ್ಪಟ್ಟು | Nippattu"
            category="box-12"
            image="https://m.media-amazon.com/images/I/61IJJ+JrXXL._AC_UL480_QL65_.jpg"
            price="114"
          />
        </div>
      </div>
    </div>
  );
}

export default BestSeller;
